import Link from 'next/link'
import Image from 'next/legacy/image'
import classNames from 'classnames'

import { t } from '../../../../utils'

import styles from './_storeProductTabs.module.scss'

import multitrackImg from '@public/images/store/multitrack.svg'
import patchesImg from '@public/images/store/patches.svg'
import vocalTracksImg from '@public/images/store/vocaltracks.svg'
import { storeSongPath } from '../../../../utils/routeHelpers'
import { Song } from '../../../../__generated__/graphql'
import { ReactSVG } from 'react-svg'

export enum StoreItemTypeEnum {
  MultiTracks = 'multi_tracks',
  PremiumPatches = 'premium_patches',
  VocalTracks = 'vocal_tracks',
  MainstagePatches = 'mainstage_patches'
}

interface StoreProductTabsProps {
  tab: StoreItemTypeEnum
  song?: Song
}
const StoreProductTabs: React.FC<StoreProductTabsProps> = ({ tab, song }) => {
  const multiTracksUrl = song
    ? storeSongPath(song, StoreItemTypeEnum.MultiTracks)
    : `/store/products/${StoreItemTypeEnum.MultiTracks}`
  const vocalTracksUrl = song
    ? storeSongPath(song, StoreItemTypeEnum.VocalTracks)
    : `/store/products/${StoreItemTypeEnum.VocalTracks}`
  const patchesUrl = song
    ? storeSongPath(song, StoreItemTypeEnum.PremiumPatches)
    : `/store/products/${StoreItemTypeEnum.PremiumPatches}`

  return (
    <div className={classNames('section', styles.storeProductTabSection)}>
      <div className="container">
        <div
          className={classNames(
            styles.storeProductTabs,
            'columns is-mobile is-centered'
          )}
        >
          <div className="column is-4-mobile is-3-tablet">
            <Link
              href={multiTracksUrl}
              prefetch={false}
              className={classNames(styles.storeProductTabLink, {
                [styles.isActive]: tab === StoreItemTypeEnum.MultiTracks
              })}
            >
              <div className={styles.storeProductTabLinkImg}>
                <ReactSVG src={'../../images/store/multitrack.svg'} />
              </div>
              <span>{t('Multi Tracks')}</span>
            </Link>
          </div>
          <div className="column is-4-mobile is-3-tablet">
            <Link
              href={vocalTracksUrl}
              prefetch={false}
              className={classNames(styles.storeProductTabLink, {
                [styles.isActive]: tab === StoreItemTypeEnum.VocalTracks
              })}
            >
              <div className={styles.storeProductTabLinkImg}>
                <ReactSVG src={'../../images/store/vocaltracks.svg'} />
              </div>
              <span>{t('Vocal Tracks')}</span>
            </Link>
          </div>
          <div className="column is-4-mobile is-3-tablet">
            <Link
              href={patchesUrl}
              prefetch={false}
              className={classNames(styles.storeProductTabLink, {
                [styles.isActive]: tab === StoreItemTypeEnum.PremiumPatches
              })}
            >
              <div className={styles.storeProductTabLinkImg}>
                <ReactSVG src={'../../images/store/patches.svg'} />
              </div>
              <span>{t('Premium Patches')}</span>
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}

export default StoreProductTabs
